import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router'
import { ROUTES } from '../../routes/routeConfig'
import { getLoginSessionId } from '../../utils/session'

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation()
  const token = sessionStorage.getItem('accessToken')
  const userRole = useSelector(state => state.user.role)
  const loginSessionId = getLoginSessionId()
  const entrySessionId = window.history.state?.loginSessionId

  // History entry belongs to a previous login (e.g. user pressed Back after a
  // fresh login) → don't restore that old page, start from the dashboard.
  const isStaleEntry =
    !!token &&
    !!loginSessionId &&
    !!entrySessionId &&
    entrySessionId !== loginSessionId

  // Tag the current history entry with the active login session id
  useEffect(() => {
    if (!token || !loginSessionId || isStaleEntry) return
    if (window.history.state?.loginSessionId !== loginSessionId) {
      window.history.replaceState(
        { ...window.history.state, loginSessionId },
        ''
      )
    }
  }, [location.key, token, loginSessionId, isStaleEntry])

  // If not logged in → go to login
  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  if (isStaleEntry) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  // If allowedRoles specified, check if user's role is permitted
  if (
    allowedRoles &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(userRole)
  ) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  // If logged in and authorized → allow access
  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
}

export default ProtectedRoute
